import { inject, DestroyRef, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, startWith, switchMap } from 'rxjs';
import {
  ENavigationUnitComponentSelection,
  INavigationDataTreeUnit,
} from '../../../../model/navigation.model';
import { AccountDataService } from '../../../../services/auth/account-data.service';
import { NavigationService } from '../../../../services/navigation.service';

export class NavigationButtonsBase {
  protected readonly destroyRef = inject(DestroyRef);
  protected readonly navigationService = inject(NavigationService);
  protected readonly accountData = inject(AccountDataService);

  protected readonly navigationUnits = signal<INavigationDataTreeUnit[]>([]);

  constructor(protected navigationUnit: ENavigationUnitComponentSelection) {}

  init(): void {
    this.#setNavigationUnitsObserver(this.navigationUnit);
  }

  readonly #setNavigationUnitsObserver = (
    navigationUnit: ENavigationUnitComponentSelection
  ) =>
    combineLatest([
      this.accountData.isLoggedIn$,
      this.accountData.userRoles$.pipe(startWith(undefined)),
    ])
      .pipe(
        switchMap(([isLoggedIn, userRoles]) =>
          this.navigationService.getFilterednavigationUnits$({
            componentSelection: navigationUnit,
            visibleForUsers: isLoggedIn ? userRoles : undefined,
            isLoggedIn: isLoggedIn,
          })
        ),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((filteredUnits) =>
        this.onNavigationUnitsChange(filteredUnits)
      );

  protected onNavigationUnitsChange(filteredUnits?: INavigationDataTreeUnit[]) {
    this.navigationUnits.set(filteredUnits ?? []);
  }
}
